import { render } from "./RegistrationFinished.vue?vue&type=template&id=16373637&scoped=true&ts=true"
import script from "./RegistrationFinished.vue?vue&type=script&lang=ts"
export * from "./RegistrationFinished.vue?vue&type=script&lang=ts"

import "./RegistrationFinished.vue?vue&type=style&index=0&id=16373637&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16373637"]])

export default __exports__